import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestRwdacct } from "../../entity/EntityRequestRwdacct";

export class DtoRequestRwdacctsGetRes extends EntityRequestRwdacct {
  public items: EntityRequestRwdacct[]  = [];
}
